import './mobileSplashScreen.css'
import React from 'react';

type MobileSplashScreenProps = {
    title: string;
    body: string;
};

const MobileSplashScreen: React.FC<MobileSplashScreenProps> = ({
    title,
    body,
}) => {

    return (
        <div className="mobileSplashScreen-overlay">
           <div className="mobileSplashScreen-modal">
                <div className="mobileSplashScreen-slide">
                    <h2 id="mobile-splash-title" className="mobileSplashScreen-title">
                        {title}
                    </h2>

                    <p className="mobileSplashScreen-body">
                        {body}
                    </p>
                </div>

                <button
                    type="button"
                    className="mobileSplashScreen-closeButton"
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default MobileSplashScreen;